import React, { useRef } from 'react';
import {connect} from 'react-redux';
import TicketsRegistrationPopover from './TicketsRegistrationPopover';
import {
    getDisableType, getSessionRegButtonStatus,
    isSaveASeatVisible,
    ticketsRegistrationSelector
} from '../../../selectors/AgendaSelectors';
import TicketRegistrationItem from './TicketRegistrationItem';
import config from '../../../config/config';
import { saveASeatErrorsSelector } from '../../../selectors/UserProfilePageSelector';

const ticketDisabledText = "'Save a seat' is restricted on web, using this ticket type";

function TicketsRegistrationPopoverContainer({
    tickets, closePopOver, saveASeatCallback, getRegisterBtnMessage, saveASeatTooltipText,
    session, isAuthorized, sessionView, isTicketSelectedOrDefault, selectedTicketsIds, saveASeatRequests,
    saveASeatErrors
}) {
    return (<TicketsRegistrationPopover onDone={closePopOver}>
        {(tickets).map(({
            id: ticketId,
            ticketName,
            websiteType,
            backgroundColor,
            ticketsRegisteredSession,
            ticketOverlappingSessions,
            ticketRules,
            ticketOpenForRegistration
        }) => {
            const isRegistered = ticketsRegisteredSession.includes(session.id);
            const isOpenForRegistration = ticketOpenForRegistration.includes(session.id);
            const ticketDisableType = getDisableType(session, isRegistered, ticketsRegisteredSession,
                ticketRules, ticketOverlappingSessions);
            const registration = session.registration;
            const {shouldRenderSessRegButton} = getSessionRegButtonStatus(
                {
                    isRegistered,
                    registration,
                    isOpenForRegistration
                }, isAuthorized, websiteType, tickets, selectedTicketsIds);
            const saveASeatVisible = isSaveASeatVisible(shouldRenderSessRegButton, sessionView, isAuthorized,
                isTicketSelectedOrDefault);
            const tipText = !saveASeatVisible ?
                ticketDisabledText :
                ticketDisableType ?
                    getRegisterBtnMessage(ticketDisableType) :
                    saveASeatTooltipText();

            return <TicketRegistrationItem
                key={ticketId}
                id={ticketId}
                ticketName={ticketName}
                backgroundColor={backgroundColor}
                disabled={!!ticketDisableType || !saveASeatVisible}
                active={isRegistered}
                tipText={tipText}
                onClick={saveASeatCallback(ticketId)}
                loading={saveASeatRequests[session.id] && saveASeatRequests[session.id].includes(ticketId)}
                error={!!(saveASeatErrors[session.id] && saveASeatErrors[session.id][ticketId])}/>;
        })
        }
    </TicketsRegistrationPopover>);
}

const mapStateToProps = state => ({
    tickets: ticketsRegistrationSelector(state),
    selectedTicketsIds: state.userProfilePageReducer.selectedTicketsIds,
    saveASeatRequests: state.userProfilePageReducer.saveASeatRequests,
    saveASeatErrors: saveASeatErrorsSelector(state)
});

export default connect(mapStateToProps, null)(TicketsRegistrationPopoverContainer);
